import React from 'react';

interface Props {
  color?: string;
}

const Separator: React.FC<Props> = ({ color }) => (
  <div
    style={{
      display: 'flex',
      flex: 1,
      height: 1,
      backgroundColor: color || 'white',
    }}
  />
);

export default Separator;
